module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "margin-top-card pfCard"
  }, [(_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('h2', [_vm._v("Register with us")]), _vm._v(" "), _c('v-form', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2|max:30'),
      expression: "'required|min:2|max:30'"
    }],
    attrs: {
      "name": "firstName",
      "label": "First Name",
      "id": "firstName",
      "error-messages": _vm.errors.collect('firstName'),
      "data-vv-name": "firstName",
      "required": ""
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2|max:30'),
      expression: "'required|min:2|max:30'"
    }],
    attrs: {
      "name": "lastName",
      "label": "Last Name",
      "id": "lastName",
      "error-messages": _vm.errors.collect('lastName'),
      "data-vv-name": "lastName",
      "required": ""
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "email",
      "label": "Email Address",
      "id": "email",
      "error-messages": _vm.errors.collect('email'),
      "data-vv-name": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }],
    attrs: {
      "name": "password",
      "label": "Password",
      "id": "password",
      "error-messages": _vm.errors.collect('password'),
      "data-vv-name": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    attrs: {
      "name": "confirmPassword",
      "label": "Confirm Password",
      "id": "confirmPassword",
      "error-messages": _vm.errors.collect('confirmPassword'),
      "data-vv-as": "password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "telephone",
      "label": "Telephone",
      "id": "telephone",
      "error-messages": _vm.errors.collect('telephone'),
      "data-vv-name": "telephone",
      "required": ""
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "address1",
      "label": "Address Line 1",
      "id": "address1",
      "error-messages": _vm.errors.collect('address1'),
      "data-vv-name": "address1",
      "required": ""
    },
    model: {
      value: (_vm.address1),
      callback: function($$v) {
        _vm.address1 = $$v
      },
      expression: "address1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "address2",
      "label": "Address Line 2",
      "id": "address2",
      "error-messages": _vm.errors.collect('address2'),
      "data-vv-name": "address2",
      "required": ""
    },
    model: {
      value: (_vm.address2),
      callback: function($$v) {
        _vm.address2 = $$v
      },
      expression: "address2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "town",
      "label": "Town/City",
      "id": "town",
      "error-messages": _vm.errors.collect('town'),
      "data-vv-name": "town",
      "required": ""
    },
    model: {
      value: (_vm.town),
      callback: function($$v) {
        _vm.town = $$v
      },
      expression: "town"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "county",
      "label": "County",
      "id": "county",
      "error-messages": _vm.errors.collect('county'),
      "data-vv-name": "county",
      "required": ""
    },
    model: {
      value: (_vm.county),
      callback: function($$v) {
        _vm.county = $$v
      },
      expression: "county"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "name": "postcode",
      "label": "Postcode",
      "id": "postcode",
      "error-messages": _vm.errors.collect('postcode'),
      "data-vv-name": "postcode",
      "required": ""
    },
    model: {
      value: (_vm.postcode),
      callback: function($$v) {
        _vm.postcode = $$v
      },
      expression: "postcode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [(!_vm.loading) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "ripple": "",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.onSignup
    }
  }, [_vm._v("\n                    Sign up\n                  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Already have and account?")])], 1)], 1)])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c13e2fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Signup.vue
// module id = 378
// module chunks = 0